if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


linkTag.integrity = __webpack_require__.sriExtractCssHashes[chunkId];
linkTag.crossOrigin = 'anonymous';
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	((linkTag) => {
    const onRails = !document.getElementById('v2');

    // This is temporary fix while we move alliance to css variables and off sass variables
    if (linkTag.href.includes('alliance-ui-styles')) {
      document.head.append(linkTag);
    } else if (onRails) {
      // For V1, we need to insert the link tags after a specific marker at the bottom of the page.
      // This is because the link tags are somethimes renderer in the body.
      // And adding them to the head causes issues with the styles not being applied correctly.
      let cssMarker = document.getElementById('css-chunks');

      if (!cssMarker) {
        cssMarker = document.createElement('div');
        cssMarker.id = 'css-chunks';
        document.body.append(cssMarker);
      }

      cssMarker.insertAdjacentElement('afterend', linkTag);
    } else {
      // V2 is much easier.
      document.body.prepend(linkTag);
    }
  })(linkTag);
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	1588: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
0: 1,
1230: 1,
1673: 1,
1833: 1,
1869: 1,
1883: 1,
3005: 1,
3319: 1,
3422: 1,
3645: 1,
3953: 1,
4072: 1,
4354: 1,
4384: 1,
4904: 1,
4988: 1,
5112: 1,
5901: 1,
5984: 1,
6856: 1,
6872: 1,
6988: 1,
7020: 1,
718: 1,
7288: 1,
7356: 1,
7712: 1,
8087: 1,
8436: 1,
8498: 1,
884: 1,
9104: 1,
9305: 1,
9752: 1,
9772: 1,
9832: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload